import { HttpMethods, APIContexts } from 'enums';
import axios from 'axios';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.CHANNEL}/`;

export const GetChannelLookupAPI = (props) => {
  const api = 'GetChannelLookup';
  const endpoint = `${apiHost}${apiContext}${api}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    ...props,
  });
};

export const GetBreakChannelTemplateAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetBreakChannelTemplate';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetBreakChannelTypeAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetBreakChannelType';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.breakChannelTemplateId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetBreakChannelTypeFormOptionsAPI = ({
  channelId,
  onSuccess,
  ...rest
}) => {
  const api = 'GetBreakChannelTypeFormOptions';
  const endpoint = `${apiHost}${apiContext}${api}/${channelId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportBreakPatternsAPI = async ({ channelId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  const api = 'ImportBreakPatterns';
  const url = `${apiHost}${apiContext}${api}/${channelId}`;
  try {
    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (err) {
    return { status: err.response.status, message: err.response.data.message };
  }
};

export const SaveBreakChannelTemplateAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'SaveBreakChannelTemplate';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.breakChannelTemplateId}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams.payload,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetBreakChannelEventListAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetBreakChannelEventList';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}/${queryParams.type}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetGradeArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetGradeArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportChannelArchitectureAPI = (channelId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const api = 'ImportChannelArchitecture';
  const url = `${apiHost}${apiContext}${api}?channelId=${channelId}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const ImportGradeArchitectureAPI = (channelId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const api = 'ImportGradeArchitecture';
  const url = `${apiHost}${apiContext}${api}?channelId=${channelId}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const GetChannelArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetChannelArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetChannelPlaylistTimingsSummaryByDayAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetChannelPlaylistTimingsSummary';

  const { channelId, date, draftScheduleParentId, page } = queryParams;

  const queryParts = [
    `ChannelId=${encodeURIComponent(channelId)}`,
    `Day=${encodeURIComponent(date)}`,
  ];

  if (draftScheduleParentId !== undefined && draftScheduleParentId !== null) {
    queryParts.push(
      `DraftScheduleParentID=${encodeURIComponent(draftScheduleParentId)}`,
    );
  }

  if (page !== undefined && page !== null) {
    queryParts.push(`page=${encodeURIComponent(page)}`);
  }

  const queryString = queryParts.join('&');
  const endpoint = `${apiHost}${apiContext}${api}?${queryString}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetMinutageArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetMinutageArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ImportMinutageArchitectureAPI = (channelId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const api = 'ImportMinutageArchitecture';
  const url = `${apiHost}${apiContext}${api}?channelId=${channelId}`;
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const ExportChannelArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'ExportChannelArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType: 'arraybuffer',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportBreakChannelTypeAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'ExportBreakChannelType';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.breakChannelTemplateId}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams.payload,
    method: HttpMethods.POST,
    responseType: 'arraybuffer',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const DeleteBreakChannelTemplateAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'DeleteBreakChannelTemplate';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.id}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetChannelBlockReferenceAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetChannelBlockReference';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
export const SaveChannelArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'SaveChannelArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams.payload,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const SaveGradeArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'SaveGradeArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams.payload,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const SaveMinutageArchitectureAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'SaveMinutageArchitecture';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    payload: queryParams.payload,
    method: HttpMethods.POST,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportChannelArchitectureGradeAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'ExportChannelArchitectureGrade';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType: 'arraybuffer',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const ExportChannelArchitectureMinutageAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'ExportChannelArchitectureMinutage';
  const endpoint = `${apiHost}${apiContext}${api}/${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    responseType: 'arraybuffer',
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetChannelByIdAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetChannelById';
  const endpoint = `${apiHost}Channel/${api}/${queryParams}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
